module.exports = __webpack_public_path__ + "img/promote_thumbnail.b881fac6.jpg";